import { useEffect, useRef } from 'react';
import { track } from '../utils/analytics.js';

// Site-wide BFCM offer bar, linking to the /order-editing-bfcm landing page.
//
// The day count and the end-of-offer hide are set after mount as ATTRIBUTES
// (data-days, shown by CSS ::after; hidden), never as text: routes are
// prerendered at build time and hydrated, and a text node that differs between
// the build-day HTML and the visitor's render is a hydration mismatch (React
// #418) that makes React throw away the server HTML. Attribute differences are
// left alone during hydration, so the visitor's own date simply takes over.
const OFFER_URL = '/order-editing-bfcm';
const DEADLINE = new Date(2026, 10, 15); // Nov 15, end of day in the visitor's time zone

function daysLeft() {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((DEADLINE - today) / 86400000);
}

export default function AnnouncementBar() {
  const barRef = useRef(null);
  const daysRef = useRef(null);

  useEffect(() => {
    const left = daysLeft();
    if (left < 0) {
      // offer over: the bar goes away rather than advertise a closed deadline
      if (barRef.current) barRef.current.hidden = true;
      return;
    }
    if (daysRef.current) {
      daysRef.current.setAttribute('data-days',
        left > 1 ? ` · ${left} days left` : left === 1 ? ' · 1 day left' : ' · last day');
    }
  }, []);

  const onClick = () => {
    track('cta_click', { cta: 'bfcm_announcement', location: window.location.pathname });
  };

  return (
    <a ref={barRef} href={OFFER_URL} className="ae-announce" onClick={onClick} suppressHydrationWarning>
      <span className="ae-announce__text">
        BFCM offer: <b>20% off</b> your first 3 months. Install by Nov 15
        <span ref={daysRef} className="ae-announce__days" suppressHydrationWarning />
      </span>
      <i className="ae-announce__go" aria-hidden="true">&rarr;</i>
    </a>
  );
}
